import styled from "styled-components";
import {
  color,
  spacing,
  borderRadius,
  elevation,
  dimension,
} from "@conserveit/blocks";

/** Implements the background for the entire page */
export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${color.theme.appBackground};
`;

/**
 * The flex child to push the entire content area to the bottom
 */
export const Container = styled.div`
  flex-grow: 1;
`;

/**
 * Wraps the page content to impose a maximum width, balanced margins, and
 * padding
 */
export const Wrap = styled.div`
  position: relative;
  max-width: ${dimension.maxWidth.mainContent};
  min-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: ${spacing.extraLoose};
`;

/**
 * Wraps the area above PageContent. Typically contains text of some sort
 * describing the page.
 */
export const PageHeader = styled.div`
  display: flex;
  margin-bottom: ${spacing.default};
  align-items: center;
  justify-content: center;
`;

/**
 * Typically a child of PageContent, wraps the primary content on the page and
 * applies a Frame-esque style.
 */
export const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: ${spacing.extraLoose};
  border-radius: ${borderRadius.large};
  box-shadow: ${elevation.content};
  background: ${color.pureWhite};
`;

export const TopMargin = styled.div`
  margin-top: 40px;
  flex-grow: 1;
  min-width: 0;
`;

export const LeftMargin = styled.div`
  margin-left: 30px;
`;

export const Margin = styled.div`
  margin: 25px 0;
  flex-grow: 1;
  min-width: 0;
`;

export const GridMargin = styled.div`
  margin: 15px;
`;

export const ChartMargin = styled.div`
  margin: 30px 0 30px 20px;
  flex-grow: 1;
  min-width: 0;
`;
